import { getAppBaseUrl } from '../infra/getAppBaseUrl'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

declare global {
  interface Window {
    staticsUrl?: string
  }
}

export const getAssetUrlInPanel = (relativeUrl: string): string =>
  window.staticsUrl
    ? `${window.staticsUrl}${relativeUrl.replace('./', '')}`
    : relativeUrl

export const getAssetUrlInWorker = async (
  editorSdkProxy: EditorSDK,
  relativeUrl: string,
): Promise<string> => `${await getAppBaseUrl(editorSdkProxy)}/${relativeUrl}`
